import Icon from "./Icon";
import Image from "./Image";

const graphicsRenderers = {
  icon: Icon,
  image: Image,
};

export default graphicsRenderers;
